import { useEffect, useState } from 'react';

import { getFromDB, saveToDB } from './db'

import Webcam from './webcam';

const startDate = new Date();
startDate.setFullYear(2026);
startDate.setDate(25);
startDate.setMonth(startDate.getMonth() - 2); //starts at 0
startDate.setHours(23);
const now = new Date();

const COUNT_DAYS = 13 * countDays(startDate);

const SERVER = `https://camera.solognot.net`;

const ALL_DATA = { webcam: [], webcam2: [] };

export default Loader;

function Loader() {
    const [done, setDone] = useState(false);
    const [currentDate, setCurrentDate] = useState(startDate);

    useEffect(() => {
        getDataForDate(currentDate, next => {
            if (next) {
                setCurrentDate(next);
            } else {
                setDone(true);
            }
        });
    }, [currentDate]);

    if (done) {
        return <Webcam data={ALL_DATA} server={SERVER} />
    } else {
        return <div >
            {/*} <audio autoplay >
                <source src="/audio.mp3" type="audio/mpeg"></source>
            </audio> */}
            <div>Chargement des images...{COUNT_DAYS}</div>
            <div><progress min={1} max={COUNT_DAYS} value={ALL_DATA.webcam.length}></progress></div>
            <div><progress min={1} max={COUNT_DAYS} value={ALL_DATA.webcam2.length}></progress></div>
        </div>
    }
}

function getDataForDate(currentDate, cb) {

    getDataTypeForDate('webcam', currentDate, () => {

        console.log(currentDate, ALL_DATA.webcam.length, ALL_DATA.webcam2.length);

        if(today(currentDate)) {
            //load extra for today
            loadJSON('webcam', currentDate, cb);
            return;
        }

        const next = incDate(currentDate);
        cb(next);

    });
}

function today(date) {
    return date.getFullYear() === now.getFullYear() &&
        date.getMonth() === now.getMonth() &&
        date.getDate() === now.getDate();
}

function countDays(start) {
    let i = 1;
    for (; ; i++) {
        start = incDate(start);
        if (start >= now) break;
    }
    return i;
}

function incDate(date) {
    return new Date(date.getTime() + 24 * 3600 * 1000);
}

function getDataTypeForDate(type, currentDate, done) {
    const path = getType(type, currentDate);
    getFromDB(path, (err, data) => {
        if (err || !data) {
            loadJSON(type, currentDate, done);
        } else {
            addJSON(type, data);
            done();
        }
    });
}

function loadJSON(type, date, cb) {
    const path = getType(type, date);
    getJSON(path, (err, json) => {
        addJSON(type, json);
        saveToDB(path, json, (err, msg) => {
            cb();
        });
    });
}

function getJSON(path, cb) {
    fetch(`${SERVER}/images?type=${encodeURIComponent(path)}`).then(resp => resp.json()).then(json => {
        cb(null, json);
    });
}

function addJSON(type, json) {
    json.forEach(f => {
        if (ALL_DATA[type].includes(f))
            return;
        ALL_DATA[type].push(f);
        const img = new Image();
        img.src = `${SERVER}/${f}`;
        window[f] = img;
    });
}

function getType(type, date) {
    return `${type}/${fill(date.getFullYear())}/${fill(date.getMonth() + 1)}/${fill(date.getDate())}`;
}

function fill(n) {
    return n < 10 ? '0' + n : n;
}